"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const RadioGroupWrapper_1 = tslib_1.__importDefault(require("../wrappers/RadioGroupWrapper"));
/**
 * @deprecated use {@link HorizontalValueTabCustomElement} or {@link HorizontalViewTabCustomElement} instead
 */
class RadioTabPanel extends fmko_ts_common_1.Widget {
    constructor(idSynthesizer) {
        super();
        this.idSynthesizer = idSynthesizer;
        this.radioButton2TabDesc = new Map();
        this.id2TabDesc = new Map();
        this.groupName = this.idSynthesizer.createId();
        this.radioPanel = document.createElement("div");
        this.radioPanel.className = "radio-tab-holder";
        this.dl = document.createElement("dl");
        this.radioPanel.appendChild(this.dl);
        this.widgetPanel = document.createElement("div");
        this.widgetPanel.className = "radio-tab-content";
        this.element = document.createElement("div");
        this.element.appendChild(this.radioPanel);
        this.element.appendChild(this.widgetPanel);
        this.element.className = "radio-tabs-outer clearfix";
        this.radioGroup = new RadioGroupWrapper_1.default();
        this.radioGroup.addValueChangeHandler((event) => {
            this.newSelection(event.getValue());
        });
    }
    addTab(id, labelText, widget) {
        const dt = document.createElement("dt");
        if (!this.dl.hasChildNodes()) {
            dt.className = "first";
        }
        const radioButton = document.createElement("input");
        radioButton.type = "radio";
        radioButton.name = this.groupName;
        const label = document.createElement("label");
        label.innerText = labelText;
        label.insertBefore(radioButton, label.firstChild);
        dt.appendChild(label);
        this.dl.appendChild(dt);
        const tabDesc = {
            id: id,
            radio: radioButton,
            widget: widget
        };
        this.radioButton2TabDesc.set(radioButton, tabDesc);
        this.id2TabDesc.set(id, tabDesc);
        this.radioGroup.wrap([radioButton]);
        this.add(widget, this.widgetPanel);
        widget.setVisible(false);
    }
    setTabVisible(id, visible) {
        const tabDesc = this.id2TabDesc.get(id);
        if (tabDesc) {
            fmko_ts_common_1.Widget.setVisible(tabDesc.radio.parentElement.parentElement, visible);
            if (!visible && id === this.getSelectedIndex()) {
                this.selectFirstVisibleTab();
            }
        }
        this.setCssClassOnFirstVisibleTab();
    }
    isTabVisible(id) {
        const tabDesc = this.id2TabDesc.get(id);
        return tabDesc && fmko_ts_common_1.Widget.isVisible(tabDesc.radio.parentElement.parentElement);
    }
    getSelectedIndex() {
        return this.selected && this.selected.id;
    }
    newSelection(radio) {
        const tabDesc = this.radioButton2TabDesc.get(radio);
        if (this.selected) {
            this.selected.widget.setVisible(false);
            fmko_ts_common_1.Widget.setStyleName(this.selected.radio.parentElement.parentElement, "selected", false);
        }
        this.selected = this.radioButton2TabDesc.get(radio);
        tabDesc.widget.setVisible(true);
        fmko_ts_common_1.Widget.setStyleName(radio.parentElement.parentElement, "selected", true);
    }
    setSelectedIndex(index) {
        const dt = this.dl.childNodes[index];
        const radio = dt.getElementsByTagName("input")[0];
        radio.checked = true;
        this.newSelection(radio);
    }
    setSelectedTab(id) {
        const tabDesc = this.id2TabDesc.get(id);
        tabDesc.radio.checked = true;
        this.newSelection(tabDesc.radio);
    }
    setRadiosEnabled(enabled) {
        this.radioButton2TabDesc.forEach((tab, radio) => {
            radio.disabled = !enabled;
        });
    }
    selectFirstVisibleTab() {
        const dts = Array.prototype.slice.call(this.dl.getElementsByTagName("dt"));
        for (let dt of dts) {
            if (fmko_ts_common_1.Widget.isVisible(dt)) {
                const input = dt.firstElementChild.firstElementChild;
                const tabDesc = this.radioButton2TabDesc.get(input);
                this.setSelectedIndex(tabDesc.id);
                return;
            }
        }
    }
    setCssClassOnFirstVisibleTab() {
        let first = true;
        const dts = Array.prototype.slice.call(this.dl.getElementsByTagName("dt"));
        for (let dt of dts) {
            if (fmko_ts_common_1.Widget.isVisible(dt)) {
                if (first) {
                    dt.classList.add("first");
                    first = false;
                }
                else {
                    dt.classList.remove("first");
                }
            }
        }
    }
}
exports.default = RadioTabPanel;
//# sourceMappingURL=RadioTabPanel.js.map